export default __webpack_public_path__ + "static/media/pause-icon.63b607a5.svg";